module.exports = __webpack_public_path__ + "static/0066-89472ddb1a190af0a74c05fc46d71f63.png";